import type { NotificationBanner } from "@/generated/sb";
import { NotificationBanner as NotificationBannerUI } from "@repo/ui-parkmobile/NotificationBanner";
import {
  storyblokEditable,
  StoryblokServerRichText,
  MarkTypes,
} from "@storyblok/react/rsc";
import { StoryblokRichTextNode } from "@storyblok/react/rsc";
import React, { ReactElement } from "react";
import { LinkRichText } from "./LinkRichText";
import { hashString } from "@repo/utils/hashString";
import { NotificationBannerHeightScript } from "./NotificationBannerHeightScript";

export interface NotificationBannerProps {
  blok: NotificationBanner;
}

export function NotificationBanner({ blok }: NotificationBannerProps) {
  if (!blok?.text) return null;

  // Key dismissal by content hash, not just _uid: editing the text changes the
  // hash → new key → banner re-appears even for users who dismissed the old text.
  const storageKey = `notification-banner-${blok._uid}-${hashString(JSON.stringify(blok.text))}`;

  const resolvers = {
    [MarkTypes.LINK]: (node: StoryblokRichTextNode<ReactElement>) => {
      if (!node?.text) return null;

      return (
        <LinkRichText
          key={hashString(node.text)}
          blok={node}
          className="uipm:underline uipm:decoration-solid uipm:text-[var(--typography-colors-text-accent)] uipm:decoration-[var(--typography-colors-text-accent)] uipm:underline-offset-2 uipm:transition-all uipm:duration-200 hover:uipm:no-underline"
        />
      );
    },
  };

  return (
    <>
      <NotificationBannerUI
        {...storyblokEditable(blok)}
        storageKey={storageKey}
      >
        <StoryblokServerRichText
          doc={blok.text as StoryblokRichTextNode<React.ReactElement>}
          // @ts-expect-error: TODO: fix types
          resolvers={resolvers}
        />
      </NotificationBannerUI>
      <NotificationBannerHeightScript storageKey={storageKey} />
    </>
  );
}
